import { Box, Heading } from '@wix/design-system';
import React from 'react';
import { DomainSearchGateModule } from '../../../../module/domainSearchGate.module';
import { InfoRow } from './InfoRow';
const FALLBACK = '—';
export const RegistrantSection = _ref => {
  var _registrant$phone;
  let registrant = _ref.registrant;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const valueOrFallback = v => !registrant.redacted && v ? v : FALLBACK;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP4"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "medium",
    as: "h2"
  }, t('domain_search_gate.whois_results.info_card.registrant_contact.title')), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP3"
  }, [{
    key: 'name',
    label: t('domain_search_gate.whois_results.info_card.registrant_contact.name.label'),
    value: registrant.name
  }, {
    key: 'email',
    label: t('domain_search_gate.whois_results.info_card.registrant_contact.email.label'),
    value: registrant.email
  }, {
    key: 'phone',
    label: t('domain_search_gate.whois_results.info_card.registrant_contact.phone.label'),
    value: (_registrant$phone = registrant.phone) == null ? void 0 : _registrant$phone.replace(/^tel:/i, '')
  }, {
    key: 'address',
    label: t('domain_search_gate.whois_results.info_card.registrant_contact.address.label'),
    value: registrant.address
  }, {
    key: 'org',
    label: t('domain_search_gate.whois_results.info_card.registrant_contact.organization.label'),
    value: registrant.org
  }].map(f => /*#__PURE__*/React.createElement(InfoRow, {
    key: f.key,
    label: f.label,
    value: valueOrFallback(f.value)
  }))));
};
//# sourceMappingURL=RegistrantSection.js.map